module.exports = __webpack_public_path__ + "static/media/emojis2_08.7ea2488c.svg";